import { getVisibleExamItems } from "./disabilityExtremityVisibility";

const ANSWER_FIELDS = [
  "answer",
  "subAnswer",
  "subAnswer2",
  "subAnswer3",
  "textAnswer",
];

const CHILD_KEYS = [
  "questions",
  "subItems",
  "subItems2",
  "subItems3",
  "options",
  "scars",
];

function hasValue(value) {
  if (Array.isArray(value)) {
    return value.some(hasValue);
  }

  return value !== undefined && value !== null && value !== "";
}

function hasSelectedResponse(node) {
  if (!node || typeof node !== "object") return false;

  if (ANSWER_FIELDS.some((field) => hasValue(node[field]))) {
    return true;
  }

  return CHILD_KEYS.some(
    (childKey) =>
      Array.isArray(node[childKey]) &&
      node[childKey].some((childNode) => hasSelectedResponse(childNode))
  );
}

function normalizeRules(rules) {
  if (!rules) return [];
  return Array.isArray(rules) ? rules : [rules];
}

function getValueByPath(source, path) {
  if (!source || !path) return undefined;

  return String(path)
    .split(".")
    .reduce((value, key) => (value ? value[key] : undefined), source);
}

function valueMatchesRule(value, rule) {
  const expectedValues = Array.isArray(rule.answers)
    ? rule.answers
    : [rule.answer];

  return expectedValues.some((expectedValue) => value === expectedValue);
}

function selectionCountMatchesRule(items, rule) {
  if (
    !Array.isArray(items) ||
    !Number.isInteger(rule.selectionCount) ||
    rule.selectionCount < 0
  ) {
    return false;
  }

  const selectedCount = getVisibleExamItems(items).filter(
    (item) =>
      item.show !== false &&
      hasValue(getValueByPath(item, rule.answerField || "answer"))
  ).length;

  return selectedCount === rule.selectionCount;
}

function getAnswerConfirmation(question) {
  const rules = normalizeRules(question && question.confirmationWhenAnswer);

  for (const rule of rules) {
    const isSelectionCountRule = Object.prototype.hasOwnProperty.call(
      rule,
      "selectionCount"
    );
    const value = getValueByPath(
      question,
      rule.answerPath || (isSelectionCountRule ? "questions" : "answer")
    );
    const matches = isSelectionCountRule
      ? selectionCountMatchesRule(value, rule)
      : valueMatchesRule(value, rule);

    if (matches) {
      return rule;
    }
  }

  return null;
}

export function getQuestionConfirmation(question) {
  if (!question) return null;

  if (question.confirmationWhenUnanswered && !hasSelectedResponse(question)) {
    return question.confirmationWhenUnanswered;
  }

  return getAnswerConfirmation(question);
}

export function shouldConfirmUnansweredQuestion(question) {
  return !!getQuestionConfirmation(question);
}
